// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getJobPaymentHistoryClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetJobPaymentHistoryClientApi = createAsyncThunk(
  "hitGetJobPaymentHistoryClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getJobPaymentHistoryClient;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetJobPaymentHistoryClientSlice = createSlice({
  name: "getJobPaymentHistoryClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetJobPaymentHistoryClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetJobPaymentHistoryClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetJobPaymentHistoryClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetJobPaymentHistoryClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetJobPaymentHistoryClientData } = GetJobPaymentHistoryClientSlice.actions;
export default GetJobPaymentHistoryClientSlice.reducer;
